
<template>
  <div :class="'detail' ">
    <Cutscenes v-if="showCutscenes"></Cutscenes>
    <DownloadNav :ifShow="ifShow"></DownloadNav>
    <!-- <div :class="'video-content ' + (isVideo ? '' : 'hidden-video')">
      <video ref="video" src="http://image.xiziquan.com/video/Fo_Zub-ha-6dJxDydMh8w3gxLhc9.mp4" @click="playVideo" @ended="ended"></video>
      <div class="video-btn" :hidden="playing" @click.stop="playVideo"></div>
    </div> -->
    <div :class="'detail-content' ">

      <div class="swipe-box" v-if="poData&&poData.images.length&& !isVideo">
        <Swipe :showIndicators="false" :auto="0" class="swipe-content" @change="handleChange" :continuous="false">
          <SwipeItem v-for="(item, index) in poData.images" :key="item.url" :alt="index">
            <div :style="`background-image:url(${item.hd_url})`" class="carouse-item"></div>
          </SwipeItem>
        </Swipe>
        <div class="post-info-bottom">
          <div class="post-info-left">
            <div class="likers">
              <img :src="item.face" v-for="(item, index) in poData.praise" :key="index" class="likers-avatar" v-if="index < 3" alt="" srcset="">
            </div>
            <span v-if="parseInt(poData.praise_count) != 0">{{poData.praise_count}}赞</span>
            <span v-if="parseInt(poData.collect_count )!= 0">{{poData.collect_count}}收藏</span>
          </div>
          <div class="post-info-right">
            <span>{{poData.views}}阅读</span>
          </div>
        </div>
        <span class="indicators" v-if="poData.images.length > 1">
          {{poData.images.length > 1 ? swipeIndex+1 : 1}}/{{poData.images.length}}
        </span>
      </div>
      <div :class="'video ' + (playing ? 'full' : '' )" v-if="poData&&isVideo">
        <video ref="video" webkit-playsinline playsinline x5-playsinline x-webkit-airplay="allow" :poster="poData.images[0].url" :src="poData.images[1].url" @click="playVideo" @ended="ended"></video>
        <div class="video-btn" :hidden="playing" @click.stop="playVideo"></div>
        <div class="post-info-bottom">
          <div class="post-info-left">
            <div class="likers">
              <img :src="item.face" v-for="(item, index) in poData.praise" :key="index" class="likers-avatar" v-if="index < 3" alt="" srcset="">
            </div>
            <span>{{parseInt(poData.praise_count)}}赞</span>
            <span>{{parseInt(poData.collect_count)}}收藏</span>
          </div>
          <div class="post-info-right">
            <span>{{poData.views}}阅读</span>
          </div>
        </div>
      </div>
      <div class="post-info" v-if="poData">
        <div class="post-user">
          <div class="post-user-left">
            <img :src="poData.user.face" class="user-avatar" alt="">
            <div class="info">
              <span :class="'user-nickname '+ 'sex_'+poData.user.gender  ">{{poData.user.username}}</span>
              <span class="user-po-time">{{poData.dateline|timestamp2txt}}</span>
            </div>
            <div class="post-identity">
              <img class="post-medal" :src="item" v-for="(item , index) in poData.user.icons" :key="index" alt="">
              <img class="post-medal" :src="item.medal_icon" v-for="(item , index) in poData.user.medals" :key="item.medal_id" :alt="index">
            </div>
          </div>
          <div class="post-user-right">
            <img :src="poData.tag.tag_stick ||  poData.sticker" v-if="poData.tag.tag_stick ||  poData.sticker" class="po-sticker" alt="">
          </div>
        </div>
        <div class="post-content">
          <span class="tag" v-show="poData.tag && poData.tag.tag_id" @click="toTag(poData.tag.tag_id)">#{{poData.tag.tag_name}} </span>
          <div v-html="contentFilters(poData.content)"></div>
        </div>
        <div v-if="poData.labels.length != 0" class="post-tags">
          <span class="tag-icon margin"></span>
          <span class="tag margin" v-for="(item, index) in poData.labels" :key="index" @click="toLabel(item.label_id)">{{item.label_name }}</span>
        </div>
      </div>
      <div class="lottery-content">
        <p class='lottery-title'>Ta们赞了</p>
        <div class='lottery-list'>
            <div class="list-item" v-for='(item, index) in lotteries'>
              <span class='corner'>{{index+1}}</span>
              <img class='lottery-img' :src="item.face" alt="">
              <p class='lottery-username'>{{item.username}}</p>
            </div>
        </div>
      </div>

<!--
      <div class="comments" v-if="poData&&poData.comments.length">

        <template>
          <div class="comment-list">
            <div class="comment-item" v-for="(item,index) in poData.comments" v-if="index < 3" :key="index">
              <div class="line"></div>
              <div class="user_info">
                <div class="user_info_left">
                  <div class="avatar" :style="'background-image:url('+ item.cuinfo.face +')'"></div>
                  <p class="user_name">
                    <span :class="'nick sex_'+item.cuinfo.gender">{{item.cuinfo.username}}</span>
                    <span v-if="item.ruinfo.uid"> 回复 <span :class="'nick sex_'+item.ruinfo.gender">{{item.ruinfo.username}}</span></span>
                  </p>
                </div>
                <div class="time">{{item.dateline|timestamp2txt}}</div>
              </div>
              <p class="comment-txt" v-html="item.comment"></p>
            </div>
          </div>

        </template>

      </div> -->
      <!-- <div class="all-comments" @click="downApp" v-if="parseInt(poData.comment_count) > 0">
        <div class="check-all-comments" v-if="parseInt(poData.comment_count) > 3">
          打开西子湖畔App 查看全部{{parseInt(poData.comment_count)}}条评论
        </div>
      </div> -->

    </div>

  </div>
</template>

<style lang="scss" scoped>
@import "../../assets/scss/mixin.scss";
@import "lottery.scss";
</style>

<script>
import DownloadNav from "@/components/download_tab/DownloadNav.vue";
import PicBox from "@/components/pic_box/PicBox.vue";
import Cutscenes from "@/components/cutscenes/Cutscenes.vue";
import { Swipe, SwipeItem } from "mint-ui";
import Vue from "vue";
import { getParam, transformLineBreak,magicLink } from "@/untils/until.js";

var qs = require("qs");
export default {
  name: "app",
  data() {
    return {
      showCutscenes: true,
      poData: {
        id: "",
        address: "",
        content: "",
        dateline: "",
        views: "0",
        reply_num: "0",
        type: "",
        uid: "",
        tag_id: "",
        sticker: "",
        praise_count: "0",
        top_user: "0",
        ifcheck: "1",
        images: [
        ],
        cover: {

        },
        user: {
        },
        collect_count: "0",
        is_collect: "0",
        tag: {
        },
        labels: [],
        share: {

        },
        praise: [

        ],
        top_title: "",
        is_praise: 0,
        comments: [

        ],
        comment_count: "0"
      },
      page: 1,
      swipeIndex: 0,
      waterFall: {
        col_0: [],
        col_1: [],
        short: 0
      },
      loaded: false,
      hotList: [],
      isVideo: false,
      playing: false,
      ifShow: false,
      noMoreData: false,
      lotteries: []
    };
  },
  components: {
    DownloadNav,
    PicBox,
    Cutscenes,
    Swipe,
    SwipeItem
  },
  watch: {
    $route: function(route) {
      let params = route.params;
      this.page = params.po_id;
    }
  },
  created() {
    let self = this;
    let obj = {
      params: {
        id: this.$route.params.po_id,
        page: this.page
      }
    };
    if (this.$route.query.isVideo == 1) {
      this.isVideo = true;
    }
    if (getParam("from") != null) {
      obj.params.from = getParam("from");
    }
    if (getParam("isappinstalled") != null) {
      obj.params.isappinstalled = getParam("isappinstalled");
    }
    let api = "/index.php?r=web/postinfo&v=4.7.0";
    let reqData = {
      data: JSON.stringify(obj)
    };
    this.loaded = false;
    this.axios
      .post(api, qs.stringify(reqData), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      .then(response => {
        let resBody = response.data;
        if (resBody.ret == 0) {
          this.hotList = resBody.data.recommends;

          this.poData = resBody.data.info;
          this.isVideo = resBody.data.info.type == 1 ? false : true;
          this.showCutscenes = false;
          this.page = 2;
          Vue.nextTick(function() {
            self.loaded = true;
            self.formatSticker(".comment-txt");
            self.formatSticker(".post-content");
          });

          wx.ready(function() {
            wx.onMenuShareTimeline({
              title: resBody.data.info.share.share_title,
              link: resBody.data.info.share.share_url,
              imgUrl: resBody.data.info.share.share_image_url
            });
            wx.onMenuShareAppMessage({
              title: resBody.data.info.share.share_title,
              desc: "惠州生活必备-西子湖畔App",
              link: resBody.data.info.share.share_url,
              imgUrl: resBody.data.info.share.share_image_url
            });
          });
        }
      });
    let lotteryObj = {
      params: {
        po_id: this.$route.params.po_id,
        page: 1
      }
    };
    if (getParam("from") != null) {
      lotteryObj.params.from = getParam("from");
    }
    if (getParam("isappinstalled") != null) {
      lotteryObj.params.isappinstalled = getParam("isappinstalled");
    }
    let lotteryParams = {
      data: JSON.stringify(lotteryObj)
    };
    this.axios.post('/index.php?r=web/getPraiseUsers&v=4.7.0',qs.stringify(lotteryParams), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
    }).then(response => {
      let res = response.data;
      if(res.ret == 0) {
        this.lotteries = res.data
      }
    })
  },
  methods: {
    toLabel(tid) {
      this.$router.push({ name: "tagList", params: { tid: tid } });
      console.info(lid);
    },
    toTag(tid) {
      this.$router.push({ name: "newTopic", params: { tag_id: tid } });
    },
    downApp() {
            magicLink('po','pid='+ this.$route.params.po_id)

    },
    ended() {
      this.playing = false;
    },
    playVideo() {
      if (this.$refs.video.paused) {
        this.$refs.video.play();
        this.playing = true;
      } else {
        this.$refs.video.pause();
        this.playing = false;
      }
    },
    renderWaterFall(data) {
      let self = this;
      self.waterFall = {
        col_0: [],
        col_1: [],
        short: 0
      };

      if (!data.length) {
        return;
      }
      var index = 0;
      var len = data.length;
      var w = self.$refs.col_0.offsetWidth;
      calcWaterFall(data);
      function calcWaterFall(data) {
        let item = data[index];
        let imgRatio = item.cover.h / item.cover.w;
        let imgW = w;
        let imgH = w * imgRatio;
        item.cover.w = imgW;
        item.cover.h = imgH;

        self.waterFall["col_" + self.waterFall.short].push(item);
        Vue.nextTick(function() {
          let h0 = self.$refs.col_0.offsetHeight;
          let h1 = self.$refs.col_1.offsetHeight;
          self.waterFall.short = h0 <= h1 ? 0 : 1;
          index++;

          if (index >= data.length) {
            self.formatSticker(".desc ");

            return;
          }
          calcWaterFall(data);
        });
      }
    },
    jumpPoDetail(id) {
      this.$router.push({ name: `newDetail`, params: { po_id: id } });
      window.location.reload();
    },
    handleChange(index) {
      this.swipeIndex = index;
      console.info(index);
    },
    // 加载po列表数据
    loadPoListData(page, cb) {
      let api = "/index.php?r=web/postinfo&v=4.7.0";
      let reqData = {};
      let obj = {
        params: {}
      };
      obj.params = {
        page: page,
        id: this.$route.params.po_id
      };
      if (getParam("from") != null) {
        obj.params.from = getParam("from");
      }
      if (getParam("isappinstalled") != null) {
        obj.params.isappinstalled = getParam("isappinstalled");
      }

      reqData = { data: JSON.stringify(obj) };
      if (!this.loaded) {
        return;
      }
      this.loaded = false;
      this.axios
        .post(api, qs.stringify(reqData), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(res => {
          let resBody = res.data;

          if (resBody.ret == 0) {
            cb && cb(resBody.data.recommends);
          }
          this.loaded = true;
        });
    },

    onZan() {
      let self = this;
      console.info(globalData);
      if (!globalData.isLogin) {
        window.location.href =
          "http://my2.xizi.com/user/social-login?type=wx&referrer=" +
          encodeURIComponent(location.href);
        return;
      }
      let api = "/index.php?r=web/ajaxpraise&v=4.2.0";
      let preZanState = self.poData.is_praise;
      let reqData = {
        data: JSON.stringify({
          params: {
            id: self.$route.params.po_id,
            qx: preZanState // 0 点赞 1取消点赞
          }
        })
      };
      self.poData.is_praise = preZanState == 0 ? 1 : 0;
      self.axios
        .post(api, qs.stringify(reqData), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(response => {
          let resBody = response.data;
          console.log(resBody);
          if (resBody.ret !== 0) {
            self.poData.is_praise = preZanState;
          }
        })
        .catch(() => {
          self.poData.is_praise = preZanState;
        });
    },

    openAppPoTopic(tag_id) {
      location.href =
        "https://www.xiziquan.com/quan_to.php?type=po_tag&tag_id=" + tag_id;
    },

    openApp(jump = true) {
      if (jump) {
        let self = this;
        location.href =
          "https://www.xiziquan.com/quan_to.php?type=po&pid=" +
          self.$route.params.po_id;
      }
    },
    formatSticker(selector = ".desc") {
      let html = document.querySelector("html");
      let fontSize = parseFloat(html.style.fontSize);
      let dpr = html.dataset.dpr;
      let imgs = document.querySelectorAll(`${selector} img`);
      for (let i = 0; i < imgs.length; i++) {
        imgs[i].style.width = (20 * dpr) / fontSize + "rem";
      }
    }
  },
  mounted() {
    document.title = "详情";
    //主引导下载悬浮栏
    var preScrollTop = 0;
    var oNav = document.querySelector(".download_nav");
    var h = oNav.offsetHeight;

    window.addEventListener("scroll", e => {
      var sTop = document.documentElement.scrollTop || document.body.scrollTop;
      var docH =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      var winH =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (sTop == docH - winH && this.loaded) {
        this.loadPoListData(this.page, data => {
          if (data.length) {
            this.page += 1;
            this.hotList = this.hotList.concat(data);

          } else {
            this.noMoreData = true;
          }
        });
      }
      if (sTop > h) {
        this.ifShow = true;
      } else {
        this.ifShow = false;
      }
    });
  },
  updated() {}
};
</script>



// WEBPACK FOOTER //
// lottery.vue?36bfacb8